import { render } from "./MenuGroup.vue?vue&type=template&id=33fb5adc"
import script from "./MenuGroup.vue?vue&type=script&lang=js"
export * from "./MenuGroup.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MenuGroup.vue"]])

export default __exports__